import React from "react"
import { isEmpty } from "lodash-es"
import { useBackfillReportableFieldContext } from "contexts/BackfillReportableFieldContext"
import FieldLabel from "shared/FieldLabel"
import { FormsyHiddenInput } from "shared/inputs"
import { Select } from "shared/selects"

const reportableFieldOptions = (reportableFields) => reportableFields.map((reportableField) => (
  {
    label: reportableField.name,
    value: reportableField.id,
  }
))

const BackfillReportableFieldFormReportableField = () => {
  const {
    selectedCategoryId,
    selectedCategoryReportableFields,
    selectedReportableFieldId,
    selectReportableField,
  } = useBackfillReportableFieldContext()

  const noReportableFields = isEmpty(selectedCategoryReportableFields)
  const options = reportableFieldOptions(selectedCategoryReportableFields)
  const disabled = !selectedCategoryId

  return (
    <FieldLabel text="Reportable Field">
      <div className="flex flex-col gap-2">
        <Select
          backspaceDelete={false}
          disabled={disabled}
          onChange={selectReportableField}
          options={options}
          value={selectedReportableFieldId}
        />
        <FormsyHiddenInput
          name="reportableFieldId"
          required
          value={selectedReportableFieldId}
        />
        {
          selectedCategoryId && noReportableFields && (
            <p className="text-xs text-dark">
              The selected category has no reportable fields.
            </p>
          )
        }
      </div>
    </FieldLabel>
  )
}

export default BackfillReportableFieldFormReportableField
